<!--~
  ~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
  ~ to an End-User License Agreement included in a separate file named EULA.txt
  ~ that is distributed with this file.
  -->
<svg [ngSwitch]="redlineConfig.type"
     *ngIf="iconDimensions$|async; let dims"
     [attr.width]="dims.width" [attr.height]="dims.height">
    <g *ngFor="let style of classConfig.styles">
        <g *ngSwitchCase="'line'">
            <polyline [attr.points]="getLinePoints(dims.width, dims.height)"
                      [attr.fill]="style.fill && style.fill.color ? style.fill.color : 'none'"
                      [attr.stroke]="style.stroke ? style.stroke.color : null"
                      [attr.stroke-width]="style.stroke ? style.stroke.width : 2"
                      [attr.stroke-dasharray]="style.stroke ? style.stroke.lineDash : null"
            />
        </g>
        <g *ngSwitchCase="'point'">
            <g [ngSwitch]="style.type">
                <g *ngSwitchCase="'point-circle'">
                    <circle
                        [attr.r]="style.radius"
                        [attr.cx]="dims.width / 2" [attr.cy]="dims.height / 2"
                        [attr.fill]="style.fill ? style.fill.color : 'none'"
                        [attr.stroke]="style.stroke ? style.stroke.color : null"
                        [attr.stroke-width]="style.stroke ? style.stroke.width : 2"
                        [attr.stroke-dasharray]="style.stroke ? style.stroke.lineDash : null"
                    ></circle>
                </g>
                <g *ngSwitchCase="'point-star'">
                    <polygon
                        [attr.fill]="style.fill ? style.fill.color : 'none'"
                        [attr.stroke]="style.stroke ? style.stroke.color : null"
                        [attr.stroke-width]="style.stroke ? style.stroke.width : 2"
                        [attr.stroke-dasharray]="style.stroke ? style.stroke.lineDash : null"
                    ></polygon>
                </g>
                <g *ngSwitchCase="'point-icon'">
                    <image [attr.href]="style.src"
                           [attr.width]="dims.width" [attr.height]="dims.height"
                    ></image>
                </g>
            </g>
        </g>
    </g>
</svg>
